"use strict";

(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;
          if (!f && c) return c(i, !0);
          if (u) return u(i, !0);
          var a = new Error("Cannot find module '" + i + "'");
          throw a.code = "MODULE_NOT_FOUND", a;
        }

        var p = n[i] = {
          exports: {}
        };
        e[i][0].call(p.exports, function (r) {
          var n = e[i][1][r];
          return o(n || r);
        }, p, p.exports, r, e, n, t);
      }

      return n[i].exports;
    }

    for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
      o(t[i]);
    }

    return o;
  }

  return r;
})()({
  1: [function (require, module, exports) {
    'use strict'; 

    var tabs = require('./components/tabs.js');

    tabs(); 

    var dropdown = require('./components/disDropdown.js');

    dropdown(); 

    var CheckboxToSelect = require('./components/CheckboxToSelect.js');

    CheckboxToSelect(); 
  }, {
    "./components/CheckboxToSelect.js": 2,
    "./components/disDropdown.js": 3,
    "./components/tabs.js": 4
  }],
  2: [function (require, module, exports) {
    'use strict'; 

    module.exports = function () {
      function CheckboxToSelect(selector) {
        $(document).on('click.cts', selector + ' [data-inputs]', function (e) {
          if (!$(e.target).parent().find('input:radio').length) {
            e.stopPropagation();
          }
        });
        $(document).on('change.cts', selector + ' [data-inputs] input', function (e) {
          setDisplay($(this).closest(selector));
        });
        $(document).on('click', selector + ' [data-reset]', function () {
          var $select = $(this).closest('[data-container]');
          var $display = $select.find('[data-display]');
          var $inputs = $select.find('[data-inputs] input');
          $select.removeClass('selected');
          $display.text($display.attr('data-placeholder'));
          $inputs.prop('checked', false);
        });

        function setDisplay($select) {
          var display = [];
          var $display = $select.find('[data-display]');
          var $checked = $select.find('[data-inputs] input:checked');
          var placeholder = $display.attr('data-placeholder');

          if (placeholder === undefined) {
            placeholder = $display.text();
            $display.attr('data-placeholder', placeholder);
          }

          $checked.each(function () {
            display.push($(this).attr('data-value') || $(this).parent().text());
          });

          if (display.length > 0) {
            $display.html(display.join(', '));
            $select.addClass('selected');
          } else {
            $display.html(placeholder);
            $select.removeClass('selected');
          }
        }

        function refreshDisplay() {
          $(selector).each(function () {
            setDisplay($(this));
          });
        }

        refreshDisplay();
        return {
          refreshDisplay: refreshDisplay
        };
      }

      ;
      CheckboxToSelect('.js__tabselect');
    };
  }, {}],
  3: [function (require, module, exports) {

    /**
     Пример 1:
     <div style="position: relative; display: inline-block;">
     <button data-dsdd>Кнопка</button>
     <ul class="dsdd-menu">
     <li><a href="#" class="item" data-icon>Пункт 1</a></li>
     <li><a href="#" class="item" data-icon>Пункт 2</a></li>
     <li><a href="#" class="item" data-icon="circle">Пункт 3</a></li>
     <li class="sep"></li>
     <li class="title">Заголовок</li>
     <li><a href="#" class="item" data-icon="basket">Пункт 4</a></li>
     <li><a href="#" class="item" data-icon="circle">Пункт 5</a></li>
     <li><a href="#" class="item" data-icon="circle" data-count="15">Пункт 6</a></li>
     <li><a href="#" class="item" data-icon="heart" data-count="2">Пункт 7</a></li>
     <li><a href="#" class="item" data-icon="circle">Пункт 8</a></li>
     </ul>
     </div>
     */

    /**
     Пример 2:
     <div style="position: relative; display: inline-block;" data-dsdd="this">
     Кнопка
     <ul class="dsdd-menu">
     <li><a href="#" class="item" data-icon>Пункт 1</a></li>
     <li><a href="#" class="item" data-icon>Пункт 2</a></li>
     <li><a href="#" class="item" data-icon="circle">Пункт 3</a></li>
     <li class="sep"></li>
     <li class="title">Заголовок</li>
     <li><a href="#" class="item" data-icon="basket">Пункт 4</a></li>
     <li><a href="#" class="item" data-icon="circle">Пункт 5</a></li>
     <li><a href="#" class="item" data-icon="circle" data-count="15">Пункт 6</a></li>
     <li><a href="#" class="item" data-icon="heart" data-count="2">Пункт 7</a></li>
     <li><a href="#" class="item" data-icon="circle">Пункт 8</a></li>
     </ul>
     </div>
     */

    /**
     Пример 3:
     <div data-dsdd="#container">
     Кнопка
     </div>

         <div style="position: relative;" id="container">
     <ul class="dsdd-menu">
     <li><a href="#" class="item" data-icon>Пункт 1</a></li>
     <li><a href="#" class="item" data-icon>Пункт 2</a></li>
     <li><a href="#" class="item" data-icon="circle">Пункт 3</a></li>
     <li class="sep"></li>
     <li class="title">Заголовок</li>
     <li><a href="#" class="item" data-icon="basket">Пункт 4</a></li>
     <li><a href="#" class="item" data-icon="circle">Пункт 5</a></li>
     <li><a href="#" class="item" data-icon="circle" data-count="15">Пункт 6</a></li>
     <li><a href="#" class="item" data-icon="heart" data-count="2">Пункт 7</a></li>
     <li><a href="#" class="item" data-icon="circle">Пункт 8</a></li>
     </ul>
     </div>
     */

    /**
     Пример 4:
     <div style="position: relative;">
     <button data-dsdd>Кнопка</button>

         <div class="vashe-menu">
     Ваше меню, которое отображаетя по классу .open .vashe-menu {display: block;}
     </div>
     </div>
     */
    'use strict'; 

    module.exports = function () {
      var toggle = '[data-dsdd]';
      var toggle_text = '[data-dsdd-content]:not([data-dsdd])';

      function dropdown(e) {
        var $this = $(this);
        if ($this.is('.disabled, :disabled')) return; 

        var $parent = $this.closest('[data-container]');
        var isActive = $parent.hasClass('open');
        clearMenus();

        if (!isActive) {
          if (e.isDefaultPrevented()) return;
          $parent.toggleClass('open');
          var $popup = $parent.find(".dsdd-menu");

          if ($popup.length) {
            if (!$('.angle:first', $popup).length) $popup.append('<div class="angle"></div>');

            $popup.resetVerticalPosition = function () {
              this.removeClass('pos-t').removeClass('pos-b');
            };

            $popup.resetHorizontalPosition = function () {
              this.css('margin-left', 0);
              this.find('.angle:first').css('margin-left', 0);
            }; 


            $popup.setOffsetHorisontal = function (extra_length) {
              this.resetHorizontalPosition();
              var popup_width = this.outerWidth(true);
              var offset_lenght = 0;
              extra_length = parseInt(extra_length);

              if (this.offset().left < 0) {
                offset_lenght = this.offset().left * -1 + 5;
              } else if (this.offset().left + popup_width > $(window).width()) {
                offset_lenght = (this.offset().left + popup_width - $(window).width() + 5) * -1;
                if (extra_length > 0) offset_lenght = offset_lenght + extra_length + 5;
              }

              if (offset_lenght !== 0) {
                this.css('margin-left', offset_lenght);
                this.find('.angle:first').css('margin-left', offset_lenght * -1);
              }

              if (!extra_length && this.offset().left < 0) this.setOffsetHorisontal(this.offset().left * -1);
            };

            $popup.setOffsetHorisontal(); 

            $popup.resetVerticalPosition();
            $popup.addClass('pos-b');

            if ($popup.offset().top + $popup.outerHeight(true) > $(document).scrollTop() + $(window).height()) {
              $popup.resetVerticalPosition();
              $popup.addClass('pos-t');

              if ($popup.offset().top + $popup.outerHeight(true) / 4 < $(document).scrollTop()) {
                $popup.resetVerticalPosition();
                $popup.addClass('pos-b');
              }
            }
          }

          $this.focus();
        }

        return false;
      }

      function clearMenus() {
        $(toggle).each(function () {
          var $parent = $(this).closest('[data-container]');
          if (!$parent.hasClass('open')) return;
          $parent.removeClass('open');
        });
      }

      function getParent($this) {
        var selector = $this.attr('data-dsdd');
        var $parent;

        if (selector && selector !== "undefined") {
          $parent = selector === "this" ? $this : $(selector);
        }

        return $parent && $parent.length ? $parent : $this.parent();
      }

      function printContent() {
        var $this = $(this);
        var content = $this.data('dsdd-content');
        var tpl = '<div class="dsdd-menu v--content">' + content + '</div>';
        $this.append(tpl);
        $this.attr('data-dsdd', 'this');
        setTimeout(function () {
          $this.trigger('click.dis.dropdown');
        }, 50);
      }

      $(document).on('click.dis.dropdown', clearMenus).on('click.dis.dropdown', toggle, dropdown).on('click.dis.dropdown', toggle_text, printContent);
    };
  }, {}],
  4: [function (require, module, exports) {
    'use strict'; 

    module.exports = function () {
      $(document).delegate('[js-tabs] [data-button]', 'click', function (e) {
        e.preventDefault();
        var $container = $(this).closest('[js-tabs]');
        var index = $(this).data('button');
        $('[data-button]', $container).removeClass('active');
        $('[data-button=' + index + ']', $container).addClass('active');
        $('[data-tab]', $container).removeClass('active');
        $('[data-tab=' + index + ']', $container).addClass('active');
        var $sliders = $('[data-tab=' + index + ']').find('.slick-slider');

        if ($sliders.length) {
          $sliders.slick('setPosition');
          sliderAlignFix($sliders);
        }
      });
    };
  }, {}]
}, {}, [1]);